export const DISMISS_ALERT = 'alert/DISMISS_ALERT'
export const DISMISS_ALERT_GROUP = 'alert/DISMISS_ALERT_GROUP'

export const REFRESH_ALERT = 'alert/REFRESH_ALERT'
export const DISMISS_ALERT_SUCCESS = 'alert/DISMISS_ALERT_SUCCESS'
export const DISMISS_ALERT_ERROR = 'alert/DISMISS_ALERT_ERROR'

export const DISMISS_ALERT_GROUP_SUCCESS = 'alert/DISMISS_ALERT_GROUP_SUCCESS'
export const DISMISS_ALERT_GROUP_ERROR = 'alert/DISMISS_ALERT_GROUP_ERROR'
